<!-- USE CASE -->
<!-- <ConfirmPassword
:isPasswordConfirmOpen="isPasswordConfirmOpen"
:closePasswordConfirm="closePasswordConfirm"
:isModal="true"
:title="'Password'"
>
SLOT GOES IN HERE
</ConfirmPassword> -->
<!-- THE "isModal" PROP IS USED TO TOGGLE THE POSITON OF THE MODAL -->

<template>
  <Teleport to="body">
    <section
      @click="clickOutClose && closePasswordConfirm()"
      v-if="isPasswordConfirmOpen"
      :class="{
        'overlay z-[9999] fixed top-0 bottom-0 left-0 right-0 w-full overflow-hidden':
          !maintainPosition,
        'w-full': maintainPosition,
      }"
    >
      <section
        v-show="!titleAndHeader"
        class="absolute top-[8%] right-[27%] bg-white duration-300 hover:bg-orange-200 border rounded-full w-8 h-8 flex items-center justify-center"
      >
        <span @click="closePasswordConfirm" class="cursor-pointer">
          <i class="text-xs font-bold text-black pi pi-times"></i>
        </span>
      </section>

      <section
        @click.stop
        :style="{ width: `${modalWidth}px`, maxHeight: `${modalHeight}px` }"
        class="bg-[#fff] m-1 px-[20px] py-[17px] rounded-[16px] border-[2px] border-[#e9ebf0] overflow-y-auto"
        :class="{
          'center-modal': isModal,
          '': maintainPosition && !isModal,
          'bottom-right-modal': !isModal && !maintainPosition,
          // [`w-[${modalWidth}px]`]: true,
        }"
      >
        <div
          v-show="titleAndHeader"
          class="flex items-center justify-between mt-1 mb-2"
        >
          <div class="flex items-center justify-center gap-4">
            <img :src="getImage(headerImg)" v-if="isHeaderImg" />
            <p class="text-gray-800 font-medium text-[16px]">{{ title }}</p>
          </div>

          <button
            type="button"
            class="grid duration-300 rounded-full size-10 place-items-center hover:bg-gray-100"
            @click="closePasswordConfirm"
            aria-label="Close modal"
          >
            <img src="@/assets/svg/x-mark.svg" class="size-6" />
          </button>
        </div>

        <hr v-show="titleAndHeader" />

        <slot></slot>
      </section>
    </section>
  </Teleport>
</template>

<script>
import { getImage } from "@/core/helpers/utility";
import ButtonComp from "../Buttons/Button.vue";
import EpumpInputVue from "../Inputs/EpumpInput.vue";
export default {
  name: "ConfirmPassword",
  props: {
    isPasswordConfirmOpen: {
      type: Boolean,
      required: true,
    },
    splitButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    clickOutClose: {
      type: Boolean,
      required: false,
      default: true,
    },
    titleAndHeader: {
      type: Boolean,
      required: false,
      default: true,
    },
    isModal: {
      type: Boolean,
      required: false,
      default: false,
    },
    closePasswordConfirm: {
      type: Function,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    buttonText: {
      type: String,
      required: false,
    },
    buttonText2: {
      type: String,
      required: false,
    },
    buttonImg: {
      type: String,
      required: false,
    },
    headerImg: {
      type: String,
      required: false,
      default: "green-lock.svg",
    },
    buttonImg2: {
      type: String,
      required: false,
    },
    maintainPosition: {
      type: Boolean,
      required: false,
      default: false,
    },
    isHeaderImg: {
      type: Boolean,
      default: true,
    },
    modalWidth: {
      type: [Number, String],
      default: 400,
    },
    modalHeight: {
      type: [Number, String],
      default: 600,
    },
  },
  components: {
    ButtonComp,
    EpumpInputVue,
  },

  data() {
    return {
      getImage,
      // showCP: true,
    };
  },

  methods: {
    close() {
      this.showCP = false;
      this.closePasswordConfirm();
    },
    imageSrc(icon) {
      return new URL(`../../assets/svg/${icon}`, import.meta.url).href;
    },
  },
  watch: {
    // isPasswordConfirmOpen() {
    //   this.showCP = this.isPasswordConfirmOpen;
    //   // if (this.isPasswordConfirmOpen) {
    //   //   this.showCP = true;
    //   // }
    // },
  },
  computed: {},
};
</script>

<style scoped>
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.5s ease;
}

/* Element starts off-screen to the right */
.slide-enter-from,
.slide-leave-to {
  transform: translateX(100%);
}

/* Element moves to its original position */
.slide-enter-to,
.slide-leave-from {
  transform: translateX(0);
}
.overlay {
  background-color: rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(2px);
}

.center-modal {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.bottom-right-modal {
  position: absolute;
  bottom: 65px;
  right: 0%;
}
</style>
